module.exports = __webpack_public_path__ + "img/api-management-connectors-mobile.cdd9592e.svg";